import React, { useState } from "react";
import cls from "./NavBar.module.scss";
import cx from "classnames";
import { I18n } from "aws-amplify";
import TranslationKeys from "config/i18n";
import { Link } from "react-router-dom";
import { LoginRoutes } from "config/LoginConfig";
import { LoginPagePreloader } from "routes";

export type NavBarProps = { className?: string };

const NavBar: React.FC<NavBarProps> = React.memo(({ className }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  return (
    <nav className={cx(cls.menuContainer, className)}>
      <button type="button" onClick={toggleMenu} className={isMenuOpen ? cls.close : cls.burger}></button>
      <ul className={cx(cls.element, !isMenuOpen && cls.hidden)}>
        <li className={cls.btnLogin} onClick={toggleMenu}>
          <Link to={LoginRoutes.LANDING} onMouseOver={LoginPagePreloader}>
            {I18n.get(TranslationKeys.NAVBAR_LOGIN)}
          </Link>
        </li>
        <li className={cls.btnSignup} onClick={toggleMenu}>
        <a 
          href="https://www.flexport.com/form/fulfillment-talk-to-us/"
          className={cls.btnSignup}
        >
          Get Started
        </a>
      </li>
      </ul>
    </nav>
  );
});

export default NavBar;
